import { IconArrowUp as TablerIconArrowUp } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconArrowUp = /*#__PURE__*/ createOutlineIcon(TablerIconArrowUp, 'IconArrowUp');
